// src/frontend/.../Recruitment/Validation/section6.js
import errorTrackerV2 from "./Utils/ErrorTrackerV2";

export function isAnyYesSelectedS6(formData = {}) {
  return Object.keys(formData).some(
    (key) =>
      formData[key] === true && key !== "complaints" && key !== "currentDPL",
  );
}

export function validateSection6(data = {}) {
  const formData = data || {};
  const newErrors = {};

  // If data is null, all required fields are missing
  if (data === null || data === undefined) {
    newErrors["dataNotFound"] =
      "No data found for this section. Please open and save it first.";
    errorTrackerV2.setSectionErrors("section6", newErrors);
    return newErrors;
  }

  const complaintsArr = Array.isArray(formData.complaints)
    ? formData.complaints
    : [];
  const directorArr = Array.isArray(formData.director) ? formData.director : [];
  const debtArr = Array.isArray(formData.debtDetails)
    ? formData.debtDetails
    : [];

  // 1) Conditional tables
  if (formData.complaint === true) {
    complaintsArr.forEach((complaint, index) => {
      if ((complaint.customer || "").trim() === "")
        newErrors[`customer_${index}`] = "This field is required";
      if (complaint.complaintDate === "")
        newErrors[`complaintDate_${index}`] = "This field is required";
      if ((complaint.natureOfComplaint || "").trim() === "")
        newErrors[`natureOfComplaint_${index}`] = "This field is required";
      if ((complaint.outcome || "").trim() === "")
        newErrors[`outcome_${index}`] = "This field is required";
      if ((complaint.redressCompensationAmount || "").trim() === "")
        newErrors[`redressCompensationAmount_${index}`] =
          "This field is required";
    });
  }

  if (formData.directorOfFinancialServicesCompany === true) {
    directorArr.forEach((director, index) => {
      if ((director.companyName || "").trim() === "")
        newErrors[`companyName_${index}`] = "This field is required";
      if ((director.businessRelationship || "").trim() === "")
        newErrors[`businessRelationship_${index}`] = "This field is required";
    });
  }

  if (formData.outstandingDebts === true) {
    debtArr.forEach((debt, index) => {
      if ((debt.company || "").trim() === "")
        newErrors[`company_${index}`] = "This field is required";
      if ((debt.amountOfDebt || "").trim() === "")
        newErrors[`amountOfDebt_${index}`] = "This field is required";
      if ((debt.detailsOfArrangements || "").trim() === "")
        newErrors[`detailsOfArrangements_${index}`] = "This field is required";
    });
  }

  // 2) Required Yes/No questions - check for null, undefined, or empty string
  if (formData.dismissed == null || formData.dismissed === "")
    newErrors.dismissed = "This field is required";
  if (formData.receivedWarnings == null || formData.receivedWarnings === "")
    newErrors.receivedWarnings = "This field is required";
  if (
    formData.investigationOrReview == null ||
    formData.investigationOrReview === ""
  )
    newErrors.investigationOrReview = "This field is required";
  if (formData.additionalTraining == null || formData.additionalTraining === "")
    newErrors.additionalTraining = "This field is required";
  if (formData.assessedByFCA == null || formData.assessedByFCA === "")
    newErrors.assessedByFCA = "This field is required";
  if (formData.assessmentReport == null || formData.assessmentReport === "")
    newErrors.assessmentReport = "This field is required";
  if (
    formData.removedFromLendersPanel == null ||
    formData.removedFromLendersPanel === ""
  )
    newErrors.removedFromLendersPanel = "This field is required";
  if (
    formData.actedInDirectlyAuthorisedCapacity == null ||
    formData.actedInDirectlyAuthorisedCapacity === ""
  )
    newErrors.actedInDirectlyAuthorisedCapacity = "This field is required";
  if (formData.latestRMAR == null || formData.latestRMAR === "")
    newErrors.latestRMAR = "This field is required";
  if (
    formData.treatedCustomersFairly == null ||
    formData.treatedCustomersFairly === ""
  )
    newErrors.treatedCustomersFairly = "This field is required";
  if (formData.highRiskProducts == null || formData.highRiskProducts === "")
    newErrors.highRiskProducts = "This field is required";
  if (formData.complaint == null || formData.complaint === "")
    newErrors.complaint = "This field is required";
  if (formData.subjectOfBreach == null || formData.subjectOfBreach === "")
    newErrors.subjectOfBreach = "This field is required";
  if (formData.appliedToRosemount == null || formData.appliedToRosemount === "")
    newErrors.appliedToRosemount = "This field is required";
  if (
    formData.advisedOnDBPensionTransfers == null ||
    formData.advisedOnDBPensionTransfers === ""
  )
    newErrors.advisedOnDBPensionTransfers = "This field is required";
  if (
    formData.referredClientToAnotherFirm == null ||
    formData.referredClientToAnotherFirm === ""
  )
    newErrors.referredClientToAnotherFirm = "This field is required";
  if (formData.tradingNames == null || formData.tradingNames === "")
    newErrors.tradingNames = "This field is required";
  if (formData.shareholder == null || formData.shareholder === "")
    newErrors.shareholder = "This field is required";
  if (formData.currentContracts == null || formData.currentContracts === "")
    newErrors.currentContracts = "This field is required";
  if (
    formData.directorOfFinancialServicesCompany == null ||
    formData.directorOfFinancialServicesCompany === ""
  )
    newErrors.directorOfFinancialServicesCompany = "This field is required";
  if (formData.outstandingDebts == null || formData.outstandingDebts === "")
    newErrors.outstandingDebts = "This field is required";
  if (formData.currentDPL == null || formData.currentDPL === "")
    newErrors.currentDPL = "This field is required";

  if(formData.advisedOnUnregulatedInvestment == null || formData.advisedOnUnregulatedInvestment === "")
    newErrors.advisedOnUnregulatedInvestment = "This field is required";

  // 3) Conditional single fields
  if (
    formData.tradingNames === true &&
    (formData.tradingName || "").trim() === ""
  ) {
    newErrors.tradingName = "This field is required";
  }

  if (
    formData.currentDPL === true &&
    (formData.referenceNumber || "").trim() === ""
  ) {
    newErrors.referenceNumber = "This field is required";
  }



  if (
    formData.advisedOnDBPensionTransfers === true &&
    (formData.additionalInformationDBPensionTransfers || "").trim() === ""
  ) {
    newErrors.additionalInformationDBPensionTransfers =
      "This field is required";
  }

  if (
    formData.referredClientToAnotherFirm === true &&
    (formData.additionalInformationReferredClientToAnotherFirm || "").trim() ===
      ""
  ) {
    newErrors.additionalInformationReferredClientToAnotherFirm =
      "This field is required";
  }

  // 4) Additional info and files required for Section 6.1 if ANY yes selected
  // Check if any yes in 6.1 (General)
  const anyYesS6_1 = [
    formData.dismissed,
    formData.receivedWarnings,
    formData.investigationOrReview,
    formData.additionalTraining,
    formData.assessedByFCA,
    formData.assessmentReport,
    formData.removedFromLendersPanel,
    formData.actedInDirectlyAuthorisedCapacity,
    formData.latestRMAR,
    formData.treatedCustomersFairly,
    formData.highRiskProducts,
    formData.complaint,
    formData.subjectOfBreach,
    formData.appliedToRosemount,
  ].some((val) => val === true || val === "true");

  if (anyYesS6_1) {
    const ai6_1 = formData.additionalInformationS6_1;
    if (
      ai6_1 === null ||
      ai6_1 === undefined ||
      (typeof ai6_1 === "string" && ai6_1.trim() === "") ||
      !ai6_1
    ) {
      newErrors.additionalInformationS6_1 = "This field is required";
    }
  }

  // 5) Additional info and files required for Section 6.3 if ANY yes selected
  // Check if any yes in 6.3 (Other)
  const anyYesS6_3 = [
    formData.tradingNames,
    formData.shareholder,
    formData.currentContracts,
    formData.directorOfFinancialServicesCompany,
    formData.outstandingDebts,
  ].some((val) => val === true || val === "true");

  if (anyYesS6_3) {
    const ai6_3 = formData.additionalInformationS6_3;
    if (
      ai6_3 === null ||
      ai6_3 === undefined ||
      (typeof ai6_3 === "string" && ai6_3.trim() === "") ||
      !ai6_3
    ) {
      newErrors.additionalInformationS6_3 = "This field is required";
    }
  }

  // Set errors in tracker
  errorTrackerV2.setSectionErrors("section6", newErrors);

  return {
    ...newErrors,
    _isValid: Object.keys(newErrors).length === 0,
  };
}
